import { Component, Input } from '@angular/core';

import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { CommonModule } from '@angular/common';
import { ShHtmlParserComponent } from '../../../../../core/html-parser/html-parser.component';
import { ShListRowTitleComponent } from '../../../../../elements/components/list-row-title/list-row-title.component';
import { ShBaseCell } from '../_base/base-cell.component';
import { AsyncTextCell } from './async-text-cell.entity';

@Component({
    standalone: true,
    selector: 'sh-async-text-cell',
    templateUrl: './async-text-cell.component.html',
    imports: [CommonModule, ShListRowTitleComponent, ShHtmlParserComponent]
})
export class ShAsyncTextCellComponent<T> extends ShBaseCell {
    @Input() public cell!: AsyncTextCell<T>;

    public get value$(): Observable<string> {
        return this.cell.asyncData.pipe(
            map(data => this.cell.stringFactory(data)),
            startWith(this.cell.placeholder)
        );
    }
}
